import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IconSearch from "../../assets/images/icon-search-1.svg";


const Container = styled.div`
    width: 100%;
    position: relative;

    .label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 16px;
    }

    .icon {
        width: 24px;
        position: absolute;
        left: 16px;
        cursor: pointer;
    }
`;

const InputBox = styled.input`
    width: calc(100% - 72px);
    height: 50px;
    border-width: 0px;
    border-radius: 30px;
    color: #25368D;
    background-color: #F5F5F5;
    font-size: 16px;
    font-weight: 400;
    padding: 0px 16px 0px 56px;

    &.error {
        border: 1px solid #F84242;
    }

    &:disabled {
        cursor: default;
        background-color: #B3B3B333;
    }
`;

function InputSearchComponent({
    value,
    placeholder,
    labelError,
    isError,
    disable,
    styleContainer,
    classContainer,
    styleInput,
    classInput,
    onInput,
    onEnter,
}) {
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        setInputValue(value || "");
    }, [value])

    function handleInput(param) {
        if (disable) return;
        let value = param.target.value;
        setInputValue(value)
        onInput && onInput(value)
    }
    function handleKeyPress(event) {
        if (event.key === 'Enter') {
            onEnter && onEnter(event)
        }
    };
    function handleClickSearch(event) {
        onEnter && onEnter(event)
    };

    return (
        <Container className={`${classContainer || ""} vertical-center`} style={{ ...styleContainer }}>
            <InputBox
                className={`${isError ? "error" : ""} ${classInput || ""}`}
                style={{ ...styleInput }}
                placeholder={placeholder || ""}
                value={inputValue}
                disabled={disable}
                onInput={(e) => { handleInput(e) }}
                onKeyPress={handleKeyPress}
            />
            <img
                alt="img"
                className={`icon`}
                src={IconSearch}
                onClick={handleClickSearch}
            />
        </Container>
    )
}

export default InputSearchComponent;